import { Pipe, PipeTransform } from '@angular/core';
import { intlFormatDistance } from 'date-fns';

@Pipe({
  name: 'formatDistance',
})
export class FormatDistancePipe implements PipeTransform {
  // date should come in db-day-date format (yyyy-MM-dd)
  transform(date?: Date, locale?: string): string {
    if (!date) return '';

    switch (locale) {
      case 'en':
        return intlFormatDistance(date, new Date(), { locale: 'en' });
      case 'fr':
        return intlFormatDistance(date, new Date(), { locale: 'fr' });
      case 'de':
      default:
        return intlFormatDistance(date, new Date(), { locale: 'de' });
    }
  }
}
